import HighlightPanel from './highlight-panel';

export default HighlightPanel;
